export enum SORT_TYPE {
    MOST_RECENT = 'MOST_RECENT',
    GAME_TITLE = 'GAME_TITLE',
    UNPAID_TO_PAID = 'UNPAID_TO_PAID',
    PAID_TO_UNPAID = 'PAID_TO_UNPAID'
}

export enum PRIZE_TYPE {
    PHYSICAL_GOODS = 'PHYSICAL_GOODS',
    CASH = 'CASH'
}
